import { useState, useCallback } from 'react';

import { useMerchant } from '@contexts/admin/MerchantContext';
import { message } from 'antd';
import { useTranslation } from 'react-i18next';

import { merchantService } from '@services/admin/merchantService';

interface UseOrderItemColumnsResult {
  enabledColumns: string[];
  availableColumns: string[];
  loading: boolean;
  updateColumns: (columns: string[]) => Promise<boolean>;
}

/**
 * Hook for managing OrderItem secondary columns configuration.
 */
const useOrderItemColumns = (): UseOrderItemColumnsResult => {
  const { orderItemColumns, availableOrderItemColumns, updateOrderItemColumns } = useMerchant();

  const [loading, setLoading] = useState(false);
  const { t } = useTranslation('shared');

  const updateColumns = useCallback(async (columns: string[]) => {
    setLoading(true);
    try {
      const data = await merchantService.updateOrderItemColumns(columns);

      if (data.success) {
        // 只更新 Context 的 orderItemColumns，不觸發整個 currentMerchant 更新
        updateOrderItemColumns(data.data.order_item_columns || []);
        message.success(t('orders.order_items.columns_saved') as string);
        return true;
      }
      message.error((data.message || t('orders.order_items.columns_save_failed')) as string);
      return false;

    } catch (error) {
      console.error('Failed to update columns:', error);
      message.error(t('orders.order_items.columns_save_failed') as string);
      return false;
    } finally {
      setLoading(false);
    }
  }, [updateOrderItemColumns, t]);

  return {
    enabledColumns: orderItemColumns,
    availableColumns: availableOrderItemColumns,
    loading,
    updateColumns
  };
};

export default useOrderItemColumns;
